"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Places extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'places';
        this._businessDetails = initParams.business_details;
        this._locations = (0, util_1.camelArray)(initParams.locations);
        this._input = initParams.input;
    }
    set businessDetails(value) {
        console.error('Do not set objects this way');
    }
    get businessDetails() {
        return this._businessDetails;
    }
    set locations(value) {
        console.error('Do not set objects this way');
    }
    get locations() {
        return this._locations;
    }
    set input(value) {
        console.error('Do not set objects this way');
    }
    get input() {
        return this._input;
    }
}
exports.default = Places;
//# sourceMappingURL=places.js.map